import { Footer, type FooterProps } from '@lmn/contenthub-shared/components';
import ErrorBoundary from '@/app/common/components/ErrorBoundary';

const ContentHubFooter = (props: FooterProps) => (
  <ErrorBoundary id="ContentHubFooter">
    <Footer {...props} />
  </ErrorBoundary>
);

export default ContentHubFooter;
